export const scroll = () => {

    jQuery(document).ready(function ($) {
        var offset = 100;
        var speed = 250;
        var duration = 500;
        $(window).scroll(function () {
            if ($(this).scrollTop() < offset) {
                $('.toptobutton').fadeOut(duration);
            } else {
                $('.toptobutton').fadeIn(duration);
            }
        });
        $('.toptobutton').on('click', function () {
            $('html, body').animate({scrollTop: 0}, speed);
            return false;
        });
    });
}
